module.exports = __webpack_public_path__ + "static/media/PKLogo.955b12bc.ico";